export const BASE_URL = 'https://tour-booking-backend-it41.onrender.com/api/v1'
